export default __webpack_public_path__ + "static/media/ldo_ADJ_EN_nCff.de1da904.svg";